module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"author":"Author","style":"Style","genre":"Genres","tag":"Tag","addFav":"Add to Favourites","remFav":"Remove from Favorites"},"ja":{"author":"投稿者","style":"食のスタイル","genre":"ジャンル","tag":"タグ","addFav":"お気に入りに追加","remFav":"お気に入りを解除"}}')
  delete Component.options._Ctor
}
